import React from 'react';
import { Link } from 'react-router-dom';
import { getSiteName } from '../utils/theme';

const NotFound: React.FC = () => {
  return (
    <section className="pt-24 pb-24 px-4 min-h-screen flex items-center justify-center">
      <div className="text-center max-w-xl mx-auto">
        <div className="text-[8rem] md:text-[10rem] leading-none font-elegant font-bold bg-gradient-to-r from-mystic-400 to-moonlight-400 bg-clip-text text-transparent">
          404
        </div>
        <h1 className="text-3xl md:text-4xl font-elegant font-bold text-white mb-4">
          Страница не найдена
        </h1>
        <p className="text-lunar-300 mb-8 text-lg">
          Возможно, ссылка устарела или вы ошиблись адресом.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 bg-mystic-gradient text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-mystic-500/25 transition-all duration-300"
        >
          На главную {getSiteName()}
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
